import React from "react";
import TaskFormSidePanel from "./task-form-side-panel";
import TaskFormFields from "./task-form-fields";
import PropTypes from "prop-types";

export default function TaskFormMain({
  subFormLabels,
  currentSubForm,
  SaveSubForm,
  label,
  ResetFormSection,
  TabChange,
  SetDataWithSameApiName,
  AutoPopulateSubForm,
  AutoPopulateCount,
  handleCustomFormulaButtonClick,
  IsView,
  submitClicked,
  taskId,
  formStatusMap
}) {

  return (
    <div className="container-fluid p-0 h-100">
      <div className="row m-0 h-100 w-100">
        <div className="col-2 p-0 container-side-panel">
          <TaskFormSidePanel
            subFormLabels={subFormLabels}
            currentSubForm={currentSubForm}
            label={label}
            TabChange={TabChange}
            data-testid="task-form-side-panel"
            IsView={IsView}
          />
        </div>
        <div className="col-10 p-0 container-form-fields">
          <TaskFormFields
            currentSubForm={currentSubForm}
            SaveSubForm={SaveSubForm}
            totalForms={subFormLabels?.length}
            ResetFormSection={ResetFormSection}
            SetDataWithSameApiName={SetDataWithSameApiName}
            AutoPopulateSubForm={AutoPopulateSubForm}
            data-testid="task-form-fields"
            AutoPopulateCount={AutoPopulateCount}
            handleCustomFormulaButtonClick={handleCustomFormulaButtonClick}
            IsView={IsView}
            submitClicked={submitClicked}
            taskId={taskId}
            formLabel={label}
            formStatusMap={formStatusMap}
          />
        </div>
      </div>
    </div>
  );
}

TaskFormMain.propTypes = {
  subFormLabels: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.string.isRequired,
      Label: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentSubForm: PropTypes.shape({
    Id: PropTypes.string.isRequired,
  }).isRequired,
  SaveSubForm: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  ResetFormSection: PropTypes.func.isRequired,
  TabChange: PropTypes.func.isRequired,
  SetDataWithSameApiName: PropTypes.func.isRequired,
  AutoPopulateSubForm: PropTypes.func.isRequired,
  AutoPopulateCount: PropTypes.number.isRequired,
  handleCustomFormulaButtonClick: PropTypes.func,
  IsView: PropTypes.bool.isRequired,
  submitClicked: PropTypes.bool.isRequired,
  taskId: PropTypes.string.isRequired,
  formStatusMap: PropTypes.object.isRequired,
};
